<template>
  <header style="background: white;">
    <!-- Right hand side buttons -->
    <nav>
      <div class="level-right" style="padding-right: 50px">
        <div class="level-item">
          <div>
            <div v-if="userIsAuthorized && userActiveViewState !== 1">
              <b-dropdown v-if="userIsAuthorized && userOrgas.length > 0" v-model="activeOrga">
                <button class="button is-basalt" slot="trigger">
                    <span>{{ userOrgas[activeOrga].name }}</span>
                    <b-icon type="is-small" icon="angle-down"></b-icon>
                </button>

                <b-dropdown-item
                  v-for="(orga, i) in userOrgas"
                  :value="i"
                  :key="orga.kst">
                  <div class="media">
                    <div class="media-content">
                      <h3>{{ orga.name }}</h3>
                      <small>{{ orga.parentName }}</small>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <!-- Public menu -->

            <div v-if="!userIsAuthorized || userActiveViewState === 1" class="fob-public-menu" style="display: flex; flex-direction: row; justify-content: flex-end;">
              <div class="navbar is-transparent fob-public-navbar" role="navigation" aria-label="dropdown navigation">
                <div class="navbar-menu is-active">
                  <div class="navbar-end">
                    <router-link
                      v-if="this.$leurisMode === 'FOB'"
                      class="navbar-item"
                      :to="{ name: 'start' }"
                      exact
                    >
                      <b-icon icon="home" style="margin-right: 5px;" size="is-small"></b-icon>
                      <translate>menu.start</translate>
                    </router-link>

                    <router-link
                      class="navbar-item"
                      :to="{ name: 'welcome'}"
                      exact
                    >
                      <b-icon icon="home" style="margin-right: 5px;" size="is-small"></b-icon>
                      <translate>menu.start</translate>
                    </router-link>

                    <router-link
                      class="navbar-item"
                      :to="toCurrentRoute"
                      tag="a"
                    >

                    <b-icon icon="globe" style="margin-right: 5px;" size="is-small"></b-icon>
                      <translate>menu.list.public</translate>
                    </router-link>

                    <div v-if="userIsAuthorized" class="navbar-item is-hoverable has-dropdown">
                      <a class="navbar-link">
                        <b-icon icon="question-circle" style="margin-right: 5px;" size="is-small"></b-icon>
                        <translate>menu.help</translate>
                      </a>
                      <div class="navbar-dropdown">
                        <a class="navbar-item" href="https://fob.uni-leipzig.de/wiki/doku.php?id=haeufige_fragen">
                          <translate>menu.help.faq</translate>
                        </a>
                        <a class="navbar-item" href="https://fob.uni-leipzig.de/wiki/doku.php?id=start#das_allerwichtigste_in_kuerze">
                          <translate>menu.help.mostImportantInANutshell</translate>
                        </a>
                        <!-- <a class="navbar-item" href="https://fob.uni-leipzig.de/wiki/doku.php?id=bekannte_fehler">
                          <translate>menu.help.knownBugs</translate>
                        </a> -->
                        <a class="navbar-item" href="https://schulung.uni-leipzig.de/leuris-schulung">
                          <translate>menu.help.videoTutorials</translate>
                        </a>
                        <hr class="navbar-divider">
                        <div class="navbar-item">
                          Version: {{version}}
                        </div>
                      </div>
                    </div>

                    <div class="navbar-item has-dropdown is-boxed is-hoverable">
                      <a class="navbar-link">
                        <b-icon icon="flag" style="margin-right: 5px;" size="is-small"></b-icon>
                        <translate>menu.language</translate>
                      </a>
                      <div class="navbar-dropdown">
                        <a class="navbar-item" v-for="(language, key) in $language.available" :key="key"
                          :class="{'is-active': $language.current === key}"
                          @click="changeLanguage(key)"
                        >
                          <translate>{{`menu.language.${language}`}}</translate>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DateTimeHelper from '@/components/mixins/DateTimeHelper'
import PublicViewHelper from '@/components/mixins/PublicViewHelper'
import ExternalLinkProvider from '@/components/mixins/ExternalLinkProvider'

export default {
  name: 'fob-header',
  mixins: [DateTimeHelper, PublicViewHelper, ExternalLinkProvider],
  data () {
    return {
      userAction: null
    }
  },
  methods: {
    ...mapActions({
      'userLogout': 'user/logout'
    }),
    triggerUserLogout () {
      this.userLogout().then(() => this.$router.push('/login'))
    },
    onActiveViewChange (activeViewItem) {
      if (activeViewItem.id === 'profile') {
        activeViewItem.route.params.id = this.userFisPersid
      } else if (activeViewItem.id === 'external') {
        activeViewItem.route.params = this.toCurrentRoute.params
      }
      this.$router.replace(activeViewItem.route)
    },
    showActiveViewItem (activeViewItem) {
      // show by default all view items
      // expection: profile -> check if user is a researcher then show view item else not
      return activeViewItem.id !== 'profile' || this.userResearcher
    }
  },
  computed: {
    ...mapGetters({
      userOrgas: 'user/orgas',
      username: 'user/name',
      userFisPersid: 'user/fisPersid',
      userIsAuthorized: 'user/isAuthorized',
      userResearcher: 'user/researcher',
      userActiveViewStates: 'user/activeViewStates',
      publicViewSelected: 'publicView/getSelected',
      version: 'getVersion'
    }),
    activeOrga: {
      get () {
        return this.$store.getters['user/activeOrga']
      },
      set (value) {
        this.$store.dispatch('user/changeOrga', value)
        this.$router.push({ name: 'start' })
      }
    },
    userActiveViewState: {
      get () {
        return this.$store.getters['user/activeViewState']
      },
      set (id) {
        this.$store.dispatch('user/activeViewState', id)
      }
    },
    onLoginPage () {
      return this.$route.name === 'login'
    }
  }
}
</script>

<style lang="scss">
  .fob-public-menu {
    .is-active-fob-public-menu-item {
      background-color: #B02F2C !important;
    }

    .fob-public-navbar {
      .is-active {
        // color: #8AC2D1;
        color: #507d8e;
      }
    }
  }
  nav {
    border-bottom: 1px solid #d4d4d6;
  }
  nav {
    button {
      border-radius: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue